module.exports = __webpack_public_path__ + "img/background.f3a7db63.png";